export const LayoutExamId = Object.freeze({
  LEGACY: "LEGACY",
  ALLALINHORN: "ALLALINHORN",
  PIZ_LINARD: "PIZ_LINARD",
  GRAND_COMBIN: "GRAND_COMBIN",
} as const);

export type LayoutExamTypeKeys = typeof LayoutExamId[keyof typeof LayoutExamId];
export const DEFAULT_LAYOUT_EXAM: LayoutExamTypeKeys = "LEGACY";

export const LayoutExamLabel: Record<LayoutExamTypeKeys, string> = {
  [LayoutExamId.LEGACY]: "Tödi (bisher)",
  [LayoutExamId.ALLALINHORN]: "Allalinhorn",
  [LayoutExamId.PIZ_LINARD]: "Piz Linard",
  [LayoutExamId.GRAND_COMBIN]: "Grand Combin",
};

